module.exports = __webpack_public_path__ + "img/directorio_escudo.447871cb.png";